package com.wintermar.inspection.feature.presentation.auth.login

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.wintermar.inspection.core.ui.component.input.util.InputState
import com.wintermar.inspection.core.ui.component.input.util.InputStateModel
import com.wintermar.inspection.core.ui.component.input.util.InputType
import com.wintermar.inspection.core.ui.component.input.util.InputValidationType
import kotlinx.coroutines.CoroutineScope

class LoginState(
    private val scope: CoroutineScope,
    private val onSubmit: (email: String, password: String) -> Unit,
    var onLoginSuccess: (() -> Unit)? = null
) {
    var isLoading by mutableStateOf(false)
    var email = InputState(
        initialData = InputStateModel(
            label = "Email",
            placeholder = "Enter your email"
        ).defaultMandatory(
            showAsterisk = false,
            additionalTypes = listOf(InputValidationType.EMAIL)
        ),
        scope = scope
    )
    var password = InputState(
        initialData = InputStateModel(
            label = "Password",
            placeholder = "Enter your password",
            autoTrim = false,
            type = InputType.PASSWORD
        ).defaultMandatory(showAsterisk = false),
        scope = scope
    )

    private fun validInput(): Boolean {
        // trigger validation on both fields
        val isEmailValid = email.validate()
        val isPasswordValid = password.validate()

        return isEmailValid && isPasswordValid
    }

    fun onLoginClicked() {
        if (!validInput()) {
            return
        }
        onSubmit(
            email.value.text.toString(),
            password.value.text.toString()
        )
    }
}
